import type { FC } from 'react';
import React, { useMemo } from 'react';
import type { FormSpyRenderProps } from 'react-final-form';
import { FormSpy, useForm } from 'react-final-form';

import { Sender } from './sender';
import type { IAnalyticsSpy, TMappedFields, TFields, TRadioButtons } from './models';

const Middle: FC<FormSpyRenderProps<TFields & TRadioButtons> & IAnalyticsSpy> = ({
    active,
    analytics,
    dirty,
    errors,
    resident,
    values: vals,
}) => {
    const { touched, values } = useForm().getState();
    /**
     * конструирование объекта, содержаещего информацию о состоянии поля
     * зависит только от `active` и `errors`, потому что аналитика отправляется только на изменения фокуса и валидацию
     * */
    const fields = useMemo(
        () =>
            Object.entries(touched as Record<TFields, boolean>).reduce<TMappedFields>(
                (acc, [key, value]) => {
                    acc[key as TFields] = {
                        touched: value,
                        error: errors[key],
                        value: values[key],
                    };

                    return acc;
                },
                { ...touched }
            ),

        // eslint-disable-next-line react-hooks/exhaustive-deps
        [touched, errors]
    );

    /**
     * при первом рендере объект `touched` пуст
     * */
    if (Object.keys(fields).length === 0) {
        return null;
    }

    return (
        <Sender
            active={active as TFields}
            analytics={analytics}
            dirty={dirty}
            fields={fields}
            paymentSystem={values['payment-system']?.value}
            resident={resident}
            values={vals}
        />
    );
};

export const AnalyticsSpy: FC<IAnalyticsSpy> = ({ analytics, resident }) => (
    <FormSpy
        analytics={analytics}
        // @ts-ignore
        component={Middle}
        resident={resident}
        subscription={{
            active: true,
            errors: true,
            dirty: true,
            values: true,
        }}
    />
);
